<template>
  <v-os-popup :title="info.title" v-model="show" @close="close" container="body" :maxHeightFill="true">
    <iframe :src="info.pageUrl" width="100%" height="100%" frameborder="0" v-if="show" />
  </v-os-popup>
</template>
<script>
export default {
  name: 'AboutPage',
  props: {
    info: {
      type: Object,
      default: () => {
        return {}
      }
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  },
  created() {},
  mounted() {}
}
</script>
<style lang="less" scoped></style>
